/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-09-01
 * @brief EHP 사업장 관리 개발
 *
 ********************************************************************/
import React from "react";
// utils
import clog from "../../../utils/logUtils";
import NoCompanyView from "./NoCompanyView";
import CompanyView from "./CompanyView";
import CompanyInsert from "./CompanyInsert";
import CompanyUpdate from "./CompanyUpdate";
/**
 * @brief EHP 사업장 관리 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function MngtSite(props) {
    //const [isMobile, setIsMobile] = useState(false);
    //const [adminType, setAdminType] = useState("ZONE"); // ZONE, SUBZONE, ROOM
    //props
    const isMobile = props.isMobile;
    const adminType = props.adminType;
    const setParentAdminType = props.setAdminType;
    const selTree = props.selTree;
    const setParentSelTree = props.setSelTree;
    const workMode = props.workMode;
    const setParentWorkMode = props.setWorkMode;
    clog("IN MNGT SITE : " + JSON.stringify(selTree));
    return (React.createElement(React.Fragment, null,
        (selTree.company.companyId.length > 0)
            ? (workMode === "READ") &&
                React.createElement(CompanyView, { isMobile: props.isMobile, setIsMobile: props.setIsMobile, selTree: selTree, setSelTree: props.setSelTree, 
                    //setAdminType={props.setAdminType}
                    workMode: props.workMode, setWorkMode: props.setWorkMode, setPopWin: props.setPopWin })
            : (workMode === "READ") &&
                React.createElement(NoCompanyView, { setIsMobile: props.setIsMobile, selTree: selTree, setPopWin: props.setPopWin }),
        (workMode === "CREATE") &&
            React.createElement(CompanyInsert, { isMobile: props.isMobile, setIsMobile: props.setIsMobile, selTree: selTree, setSelTree: props.setSelTree, setWorkMode: props.setWorkMode, setPopWin: props.setPopWin }),
        (workMode === "UPDATE") &&
            React.createElement(CompanyUpdate, { isMobile: props.isMobile, setIsMobile: props.setIsMobile, selTree: selTree, setSelTree: props.setSelTree, setWorkMode: props.setWorkMode, setPopWin: props.setPopWin })));
}
;
export default MngtSite;
